import { gql } from '@lcs/shared/api';

export const deleteDepartmentMutation = gql`
   mutation DeleteDepartment($departmentId: UInt!) {
      deleteDepartment(id: $departmentId)
   }
`;
